export const letterP = {
  nouns: [
    {"paper": ["Papier", "Papiere", "das", "die", "n"]},
    {"documents": ["Papiere", "Papiere", "die", "die", "f"]},
    {"partner": ["Partner", "Partner", "der", "die", "m"]},
    {"female partner": ["Partnerin", "Partnerinnen", "die", "die", "f"]},
    {"party": ["Party", "Partys", "die", "die", "f"]},
    {"passport": ["Pass", "Pässe", "der", "die", "m"]},
    {"pause": ["Pause", "Pausen", "die", "die", "f"]},
    {"plan": ["Plan", "Pläne", "der", "die", "m"]},
    {"place": ["Platz", "Plätze", "der", "die", "m"]},
    {"police": ["Polizei", "Polizei", "die", "die", "f"]},
    {"fries": ["Pommes frites", "Pommes frites", "die", "die", "f"]},
    {"post office": ["Post", "Post", "die", "die", "f"]},
    {"postal code": ["Postleitzahl", "Postleitzahlen", "die", "die", "f"]},
    {"internship": ["Praktikum", "Praktika", "das", "die", "n"]},
    {"doctor\'s office": ["Praxis", "Praxen", "die", "die", "f"]},
    {"doctor\'s office": ["Arztpraxis", "Arztpraxen", "die", "die", "f"]},
    {"price": ["Preis", "Preise", "der", "die", "m"]},
    {"problem": ["Problem", "Probleme", "das", "die", "n"]},
    {"prospectus": ["Prospekt", "Prospekte", "der", "die", "m"]},
    {"exam": ["Prüfung", "Prüfungen", "die", "die", "f"]}
  ],
  verbs: [
    {"to pack": ["packen", "packe", "packst", "packt", "packt", "packt", "packen", "packt", "packen", "packen"]},
    {"to park": ["parken", "parke", "parkst", "parkt", "parkt", "parkt", "parken", "parkt", "parken", "parken"]},
    {"to fit": ["passen", "passe", "passt", "passt", "passt", "passt", "passen", "passt", "passen", "passen"]},
    {"to clean": ["putzen", "putze", "putzt", "putzt", "putzt", "putzt", "putzen", "putzt", "putzen", "putzen"]}
  ],
  examples: {
    nominative: [
      {
        german: '___ Papier ist weiß.',
        english: 'The paper is white.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Partner arbeitet.',
        english: 'The partner works.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Party ist lustig.',
        english: 'The party is fun.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Pass ist gültig.',
        english: 'The passport is valid.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Pause ist kurz.',
        english: 'The pause is short.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Plan ist gut.',
        english: 'The plan is good.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Preis ist hoch.',
        english: 'The price is high.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Problem ist schwer.',
        english: 'The problem is difficult.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Polizei kommt.',
        english: 'The police is coming.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Prüfung ist wichtig.',
        english: 'The exam is important.',
        answer: 'Die',
        case: 'nominative'
      }
    ],
    accusative: [
      {
        german: 'Ich brauche ___ Papier.',
        english: 'I need the paper.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Sie besucht ___ Partner.',
        english: 'She visits the partner.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Er macht ___ Party.',
        english: 'He makes the party.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Wir zeigen ___ Pass.',
        english: 'We show the passport.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Du brauchst ___ Pause.',
        english: 'You need the pause.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Ich habe ___ Plan.',
        english: 'I have the plan.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie zahlt ___ Preis.',
        english: 'She pays the price.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Er löst ___ Problem.',
        english: 'He solves the problem.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Wir lesen ___ Prospekt.',
        english: 'We read the prospectus.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Du bestehst ___ Prüfung.',
        english: 'You pass the exam.',
        answer: 'die',
        case: 'accusative'
      }
    ],
    dative: [
      {
        german: 'Ich helfe ___ Partner.',
        english: 'I help the partner.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie geht zu ___ Party.',
        english: 'She goes to the party.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Er spricht mit ___ Polizei.',
        english: 'He speaks with the police.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Wir danken ___ Partnerin.',
        english: 'We thank the female partner.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Du sitzt auf ___ Platz.',
        english: 'You sit on the place.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Ich gebe ___ Kind ___ Papier.',
        english: 'I give the child the paper.',
        answer: 'dem das',
        case: 'dative'
      },
      {
        german: 'Sie arbeitet für ___ Partner.',
        english: 'She works for the partner.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Er kommt aus ___ Praktikum.',
        english: 'He comes from the internship.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir leben bei ___ Post.',
        english: 'We live near the post office.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Du gehst zu ___ Polizei.',
        english: 'You go to the police.',
        answer: 'der',
        case: 'dative'
      }
    ],
    translations: [
      {
        english: 'The paper is white.',
        german: 'Das Papier ist weiß.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She visits the partner.',
        german: 'Sie besucht den Partner.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I help the partner.',
        german: 'Ich helfe dem Partner.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'The party is fun.',
        german: 'Die Party ist lustig.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'We show the passport.',
        german: 'Wir zeigen den Pass.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The plan is good.',
        german: 'Der Plan ist gut.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She pays the price.',
        german: 'Sie zahlt den Preis.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'He solves the problem.',
        german: 'Er löst das Problem.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The police comes quickly.',
        german: 'Die Polizei kommt schnell.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'You pass the exam.',
        german: 'Du bestehst die Prüfung.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The pause is short.',
        german: 'Die Pause ist kurz.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'We make a plan.',
        german: 'Wir machen einen Plan.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The price is high.',
        german: 'Der Preis ist hoch.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'I read the prospectus.',
        german: 'Ich lese den Prospekt.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The partner works hard.',
        german: 'Der Partner arbeitet hart.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She shows the passport.',
        german: 'Sie zeigt den Pass.',
        type: 'translation',
        caseType: 'accusative'
      }
    ],
    conjugations: []
  }
}
